import { Navigate } from "react-router-dom";
import SellerDashboard from "../pages/selller/dashboards";
import SalesRepresentativeDashboard from "../pages/selller/dashboards/sales-representative";
import SalesAnalyticsDashboard from "../pages/selller/dashboards/sales-analytics";
import AssignedOutlets from "../components/outletManagement/AssignedOutlets";
import Ledger from "../components/ledger/Ledger";

const salesRepRoutes = [
  { path: "maltora-sales-rep/assigned-outlets", element: <AssignedOutlets /> },
  { path: "maltora-sales-rep/ledgers/:customerId", element: <Ledger /> },
  {
    path: "maltora-sales-rep/dashboard",
    element: <SellerDashboard />,
    children: [
      { path: "sales", element: <SalesAnalyticsDashboard /> },
      {
        path: "salesrep-analytics",
        element: <SalesRepresentativeDashboard />,
      },
      { index: true, element: <Navigate to="sales" replace /> },
    ],
  },
];

export default salesRepRoutes;
